/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserWalletInfoRespVo } from './UserWalletInfoRespVo';
import {
    UserWalletInfoRespVoFromJSON,
    UserWalletInfoRespVoFromJSONTyped,
    UserWalletInfoRespVoToJSON,
    UserWalletInfoRespVoToJSONTyped,
} from './UserWalletInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseUserWalletInfoRespVo
 */
export interface ResponseUserWalletInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUserWalletInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUserWalletInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {UserWalletInfoRespVo}
     * @memberof ResponseUserWalletInfoRespVo
     */
    data?: UserWalletInfoRespVo;
}

/**
 * Check if a given object implements the ResponseUserWalletInfoRespVo interface.
 */
export function instanceOfResponseUserWalletInfoRespVo(value: object): value is ResponseUserWalletInfoRespVo {
    return true;
}

export function ResponseUserWalletInfoRespVoFromJSON(json: any): ResponseUserWalletInfoRespVo {
    return ResponseUserWalletInfoRespVoFromJSONTyped(json, false);
}

export function ResponseUserWalletInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserWalletInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UserWalletInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseUserWalletInfoRespVoToJSON(json: any): ResponseUserWalletInfoRespVo {
    return ResponseUserWalletInfoRespVoToJSONTyped(json, false);
}

export function ResponseUserWalletInfoRespVoToJSONTyped(value?: ResponseUserWalletInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UserWalletInfoRespVoToJSON(value['data']),
    };
}

